module.exports = __webpack_public_path__ + "static/media/comment-medical.93b68fde.svg";